// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6879 ? "9c7117ca" : chunkId) + "." + {"521":"b766ef233d6cc968","6879":"168c2a5e8dce5bfb","8964":"e7c8a5a3686976bd"}[chunkId] + ".js";
};